import css from './style.module.scss';
import { motion } from 'framer-motion';
import NoProductsGraphic from '../../svg/no-products.svg';

export default function NoProducts () {
	return (
		<motion.div
			className={css.noProducts}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<div>
				<NoProductsGraphic />
				<h2>No products match your selection</h2>
				<p>We can’t find any products to match your selection. Please try adjusting the filters.</p>
			</div>
		</motion.div>
	);
}
